import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {Uuid} from '../interface/response/uuid';
import {HttpClient} from '@angular/common/http';
import {first, map} from 'rxjs/operators';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {RiskConfiguration} from '../interface/risk-configuration';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {Dictionary} from '../interface/dictionary';
import {RiskGroup} from '../interface/risk-group';
import {Risk} from '../interface/risk';

@Injectable({
  providedIn: 'root'
})
export class RiskService {
  public readonly riskConfigurationListSubject: ReplaySubject<CountedAndPaginated<RiskConfiguration>>
    = new ReplaySubject<CountedAndPaginated<RiskConfiguration>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  public sendForm(formData: any, uuid?: string): Observable<Uuid> {
    if (!uuid) {
      return this.httpClient.post(`/rest/crm/risk-configuration`, formData)
        .pipe(first()) as Observable<Uuid>;
    } else {
      return this.httpClient.put(`/rest/crm/risk-configuration/${uuid}`, formData)
        .pipe(first()) as Observable<Uuid>;
    }

  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/risk-configuration?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first(),
        map((result: CountedAndPaginated<RiskConfiguration>) => {
          const orderedResult: CountedAndPaginated<RiskConfiguration> = {...result};

          orderedResult.items = result.items.map((riskConfiguration: RiskConfiguration) => {
            riskConfiguration.groups = riskConfiguration.groups
              .sort((a: RiskGroup, b: RiskGroup) =>
                a.groupName ? a.groupName.localeCompare(b.groupName) : ''.localeCompare(b.groupName)
              );

            riskConfiguration.groups.map((riskGroup: RiskGroup) => {
              riskGroup.risks.sort((a: Risk, b: Risk) =>
                a.name ? a.name.localeCompare(b.name) : ''.localeCompare(b.name)
              );

              return riskGroup;
            });

            return riskConfiguration;
          });

          return orderedResult;
        })
      )
      .subscribe((result: CountedAndPaginated<RiskConfiguration>) => {
        this.riskConfigurationListSubject.next(result);
      });
  }

  public downloadReport(filters: any): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/risk-configuration/method/report?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }

  public deleteConfiguration(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/risk-configuration/${uuid}`)
      .pipe(first());
  }

  public configure(uuid: string, formData: any): Observable<any> {
    return this.httpClient.post(`/rest/crm/risk-configuration/${uuid}/configure`, formData)
      .pipe(first());
  }
}
